// extracted by mini-css-extract-plugin
export var closed = "_h0-1";
export var resizer = "_h0-0";